import { BellIcon } from 'lucide-react'
import { type ComponentPropsWithoutRef, forwardRef, type ReactNode } from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export interface NotificationTriggerButtonProps
  extends Omit<ComponentPropsWithoutRef<'button'>, 'className'> {
  hasUnread: boolean
  unreadCount: number
  className?: string
}

export const NotificationTriggerButton = forwardRef<
  HTMLButtonElement,
  NotificationTriggerButtonProps
>(({ hasUnread, unreadCount, className, ...rest }, ref): ReactNode => {
  return (
    <Button
      ref={ref}
      variant="ghost"
      size="icon"
      className={cn(
        'notification-trigger relative text-muted-foreground hover:text-foreground',
        className
      )}
      aria-label={`Notifications${hasUnread ? ` (${unreadCount} unread)` : ''}`}
      {...rest}
    >
      <BellIcon className="size-4" />
      {hasUnread && (
        <span className="notification-badge absolute -top-0.5 -right-0.5 size-2.5 rounded-full bg-destructive" />
      )}
    </Button>
  )
})

NotificationTriggerButton.displayName = 'NotificationTriggerButton'
